// extracted by mini-css-extract-plugin
module.exports = {"form":"contactForm-module--form--2iZ5-","btn":"contactForm-module--btn--2f_nP"};